<template>
  <div class="container-fluid">
    <b-modal v-model="show" centered no-close-on-esc no-close-on-backdrop hide-header-close>
      <i 
        :class="textShow.icon"
        aria-hidden="true"
      ></i>
      <div class="custom-modal-noti">
        <h3>{{msg}}</h3>
      </div>
      <template v-slot:modal-footer>
        <div class="w-100 text-center">
            <b-button
              :variant="textShow.btnColor"
              size="xl"
              class="mx-1"
              @click="submit()" >
              {{textShow.btnSubmit}}
            </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
export default {
  props: {
      getMsg: String ,
      getShow: Boolean ,
      getType: Boolean ,
      submit : Function
    },
  data() {
    return {
      showModal: true
    }
  },
  methods: {
  },
  computed:{
    msg(){
      return this.getMsg ? this.getMsg : ''
    },
    show(){
      return this.getShow ? this.getShow : false
    },
    type(){
      return this.getType ? this.getType : false
    },
    textShow(){
      let res = {
        btnSubmit : 'ลองใหม่อีกครั้ง' ,
        btnColor : 'danger' ,
        icon : 'fa fa-exclamation-triangle fa-4x d-flex justify-content-center text-red mb-4'
      }
      if( this.type ){
        res.btnSubmit = 'ตกลง'
        res.icon = 'far fa-check-circle fa-4x d-flex justify-content-center text-green mb-4'
        res.btnColor = 'success'
      }
      return res
    }
  }
};
</script>
<style lang="scss" scoped>
  .custom-modal-noti{
    word-wrap: break-word;
    text-align: center;
  }
</style>